// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"143":"3189c643","355":"18e31b56","522":"7eea169a"}[chunkId] + ".js";
};